import styled from 'styled-components';

export const Container = styled.div`
    background-color: var(--color-black);
    margin-top: 35px;
    margin-bottom: 35px;
    width: 65%;
`;
export const SubTitle = styled.div`
    span {
        color: var(--color-gray);
    }

    h4 {
        color: var(--color-yellow);
    }

    h5 {
        font-size: 1.3rem;
    }
`;

export const Card = styled.div`
    width: 65%;
`;
